module.exports = __webpack_public_path__ + "img/2.29d62eeb.jpg";